export default {
  registration: {
    header: {
      title: '专用用户注册页面',
      // title_esg_data_share: '',
    },
    passcode: {
      section_one: '这是一个专用用户注册页面，供申请使用本服务的公司使用。请输入贵公司的公司信息、联系人姓名等。',
      section_two: '请输入链接的密码以继续。',
      section_three: '如果不知道密码，请联系向贵公司申请本服务的公司。',
      passcode: '浏览用密码',
      passcode_placeholder: '@:common.form.search_word.placeholder',
      incomplete_input: '输入内容不完整。',
      unexpected_error: '发生了意外错误。',
    },
    email: {
      section_one: '@:registration.passcode.section_one',
      section_two: '请输入负责人的电子邮件地址。',
      email: '电子邮件地址',
      email_placeholder: '请输入电子邮件地址',
    },
    sent: {
      section_one: '电子邮件已发送到您输入的 电子邮件地址。',
      section_two: '请在确认后通过电子邮件中的URL注册帐户。',
      section_three: '如果30分钟后仍未收到电子邮件，请联系',
      section_four: '',
    },
    password: {
      // TODO: section_one は日本語だと「アスエネ/アスエネESGの」を「アスエネ関連プロダクトの」に変更する対応が入っており、本言語にはそれが未反映
      section_one: '您输入的电子邮件地址已注册为ASUENE/ASUENE ESG帐户。',
      section_two: '请输入注册密码。',
      password: '密码',
      // password_placeholder: '',
      error_auth: '验证失败。请重新登录。',
      // error_linking: '',
      // same_domain_modal: {
      //   title: '',
      //   section: '',
      // },
    },
    info: {
      section_one: '@:registration.passcode.section_one',
      section_two: '请输入贵公司的公司信息、联系人姓名等。',
      section_three: '如果您在申请后使用已注册的帐户登录，您将可以回答新的问卷/调查。',
      buyer_name: '委托评估公司名称',
      expires_date: '注册页面有效期',
      deadline: '@:common.date.answer_expires_date',
    },
    form: {
      invalid_form: '@:settings.messages.invalid_form',
      company_name: '公司名称',
      company_name_placeholder: '@:common.company_name_inc',
      company_scale: '@:settings.company.scale',
      select_placeholder: '@:upload_common.target_select',
      industry_type: '@:settings.company.industry_type',
      first_name: '@:settings.user.first_name',
      last_name_placeholder: 'Yamada',
      last_name: '@:settings.user.last_name',
      first_name_placeholder: 'Taro',
      email: '@:settings.user.email',
      email_placeholder: '@:settings.user.email',
      email_text: '※将显示您输入的电子邮件地址。',
      phone: '电话号码',
      phone_placeholder: '0000000000',
      locale: '选择语言',
      section_one: '请先同意',
      rule: '使用条款',
      rule_link: '/pdf/241112_AsueneESG_Terms_and_Conditions_Supplier.pdf',
      punctuation: ' 和 ',
      policy: '隐私政策',
      policy_link: 'https://asuene.com/en/privacy',
      section_two: '然后再继续。',
      // same_domain_modal: {
      //   title: '',
      //   section: '',
      // },
    },
    thanks: {
      section_one: '感谢您的申请',
      section_two: '登录ID和密码已发送到您输入的电子邮件地址。',
      section_three: '请确认，并根据邮件内容登录。',
      section_four: '如果30分钟后仍未收到电子邮件，请联系',
      section_five: '',
      section_six: '负责人将再次与您联系。',
    },
    expired: {
      section_one: '您指定的URL已过期。',
      section_two: '如果您想使用此项服务，请联系',
      section_three: '负责人将再次与您联系。',
    },
    error: {
      section_one: '未找到指定的URL。',
      section_two: '我们对给您造成的不便深表歉意，但请再次确认 URL。',
    },
    btn: {
      submit: '发送',
      service_top: '服务首页',
      login: '登录',
      register: '注册',
      rating_url: 'https://asuene.com/rating/en',
    },
    buyer: {
      // sharing_company: "",
      // explain_message: "",
    },
  },
}
